import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DateRange } from './expenseDateRangeSelection.state';

export const getExpenseDateRangeSelectionState = createFeatureSelector< DateRange>('expenseDateRangeSelection');

export const getExpenseDateRange = createSelector(
  getExpenseDateRangeSelectionState,
  (state) => state.expenseDateRangeSelection
);